import * as React from 'react'
import { type ReactNode, useMemo } from 'react'

import type { SchedulingScreen } from '../typings'
import { selectScreenMeta, useSchedulingWizard } from './wizardContext'
import DialogContent from '@mui/material/DialogContent'

type WizardScreenProps = {
  animated?: boolean
  header?: ReactNode
  footer?: ReactNode
  children: ReactNode
  keepMounted?: boolean
  screen: SchedulingScreen
  disableBodyGrow?: boolean
  isRescheduling?: boolean
  padding?: number
}

export const WizardScreen = React.forwardRef<HTMLDivElement, WizardScreenProps>(
  (props) => {
    const { screen, header, footer, children, keepMounted } = props

    const [state] = useSchedulingWizard()
    const { active } = useMemo(
      () => selectScreenMeta(state, screen),
      [screen, state],
    )

    const render = active || keepMounted

    if (render) {
      return (
        <>
          <DialogContent sx={{ px: 0.4 }}>
            {header}
            {children}
          </DialogContent>
          {footer}
        </>
      )
    }
    return null
  },
)
